import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { pagination } from 'utils/constants';

const initialState: IExternalApiKeyState = {
    list: [],
    paginateMetaData: pagination,
};

export const externalApiKeySlice = createSlice({
    name: 'externalApiKey',
    initialState,
    reducers: {
        setExternalApiKeyList: (
            state,
            action: PayloadAction<{ list: IExternalApiKey[]; paginateMetaData: IPaginateMetaData }>,
        ) => {
            state.list = action.payload.list;
            state.paginateMetaData = action.payload.paginateMetaData;
        },
    },
});

export const { setExternalApiKeyList } = externalApiKeySlice.actions;

export default externalApiKeySlice.reducer;
